export const residentsFileHeaders = {
    facility: 'Facility',
    residentName: 'Resident',
    preferredName: 'Preferred Name',
    residentCode: 'Resident Code',
    dob: 'Date of Birth',
    admissionDate: 'Admission Date',
    isDeparted: 'Departed (Y/N)',
    discharged: 'Discharged / Deceased Date',
    bed: 'Bed',
    wing: 'Wing',
    isUsingOwnDevice: 'Using their own device',
    email: 'Email',
    address: 'Address',
    isStaffCanLoginAsResident: 'Staff can log in as resident',
    familyName: 'Family member name [index]',
    familyEmail: 'Family member email [index]',
    familyEpoa: 'Family member Epoa [index]',
    familyApp: 'Family member [index] Add to family app',
    familyCanAdd: 'Family member [index] Can add family members',
  }

  export const vendorsFileHeaders = {
    name: 'Name',
    type: 'Type',
    category: 'Category',
    email: 'Email',
    phoneNumber: 'Phone',
  }